<script>
import { cloneDeep } from 'lodash-es';
import NonDynamicTransportAllotmentRow from './NonDynamicTransportAllotmentRow';

export default {
  name: 'NonDynamicTransportAllotments',
  components: {
    NonDynamicTransportAllotmentRow,
  },
  props: {
    allotments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        this.$t('nonDynamicTransport.headers.fromDate'),
        this.$t('nonDynamicTransport.headers.toDate'),
        this.$t('nonDynamicTransport.headers.releaseDate'),
        this.$t('nonDynamicTransport.headers.releaseDays'),
        this.$t('nonDynamicTransport.headers.issue'),
        this.$t('nonDynamicTransport.headers.notifications'),
        this.$t('nonDynamicTransport.headers.pnr'),
        this.$t('nonDynamicTransport.headers.info'),
        this.$t('nonDynamicTransport.headers.allotment'),
        this.$t('nonDynamicTransport.headers.netFare'),
        this.$t('nonDynamicTransport.headers.yr'),
        this.$t('nonDynamicTransport.headers.taxes'),
        this.$t('nonDynamicTransport.headers.totalFare'),
        '%',
        this.$t('nonDynamicTransport.headers.customerPrice'),
        this.$t('nonDynamicTransport.headers.infant'),
        '%',
        this.$t('nonDynamicTransport.headers.child'),
        '%',
        this.$t('nonDynamicTransport.headers.class'),
        this.$t('nonDynamicTransport.headers.cruise'),
        this.$t('nonDynamicTransport.headers.outbound'),
        this.$t('nonDynamicTransport.headers.inbound'),
      ],
      allotment: {
        id: null,
        fromDate: null,
        toDate: null,
        releaseDate: null,
        releaseDays: null,
        comment: null,
        issue: null,
        notifications: [],
        PNR: null,
        amount: null,
        classType: null,
        fares: {
          tax: null,
          fuel: null,
          net: null,
          total: null,
        },
        prices: {
          adult: null,
          infant: null,
          child: null,
        },
        days: {
          inbound: {
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
          },
          outbound: {
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
          },
        },
      },
      localAllotments: [],
    };
  },
  created() {
    if (!this.allotments.length) {
      this.addAllotmentRow();
    } else {
      this.localAllotments = [...this.allotments];
    }
  },
  methods: {
    updateAllotments(item) {
      this.localAllotments[item.index] = item.value;
    },
    addAllotmentRow() {
      this.localAllotments.push(cloneDeep(this.allotment));
    },
    removeAllotmentRow(index) {
      const allotments = [...this.localAllotments];
      allotments.splice(index, 1);
      this.localAllotments = [...allotments];
      this.$forceUpdate();
    },
  },
  watch: {
    localAllotments: { handler(value) { this.$emit('update', value); }, deep: true },
  },
};
</script>

<template>
  <v-layout row>
    <v-flex>
      <table class="table-one mt-2 non-dynamic-transport-allotments-table">
        <tr>
          <th
            v-for="(header, index) in headers"
            :key="`table-header-${index}`"
            class="table-header"
          >
            {{ header }}
          </th>
        </tr>
        <non-dynamic-transport-allotment-row
          v-for="(allotment, index) in localAllotments"
          :key="`non-dynamic-transport-row-${index}`"
          :allotment="allotment"
          :index="index"
          @change="updateAllotments"
          @remove="removeAllotmentRow"
        />
      </table>
      <v-btn
        color="primary"
        @click="addAllotmentRow"
      >
        <v-icon dark left>add_circle</v-icon>
        {{ $t('buttons.addAllotment') }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>


<style scoped lang="scss">
  @import '../../assets/scss/variables';

  .non-dynamic-transport-allotments-table {
    width: 100%;
  }

  .table-header {
    font-size: $font-size-sm;
  }
</style>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportAllotments.vue